/**
 * Analytics Header Component
 * Consolidated header for Analytics page with property name, period, KPIs, and controls
 * ANALYTICS_HEADER_ROW1: Icons aligned with property name baseline (top-right)
 * ANALYTICS_HEADER_ROW2: Controls row with period, date range, and channel filters
 */
import React, { useState } from 'react';
import CompactChannelFilter from './CompactChannelFilter.jsx';
import AnalyticsPeriodTrigger from './AnalyticsPeriodTrigger.jsx';
import GuideModal from './GuideModal.jsx';

export default function AnalyticsHeader({
  propertyName,
  dateRangeDisplay,
  channels,
  selectedChannels,
  onChannelsChange,
  comparison,
  selectedChannel,
  renderIconsInRow1 = false,
  hideChannelFilter = false,
}) {
  const [showGuideModal, setShowGuideModal] = useState(false);

  const showTwoRowLayout = !hideChannelFilter && channels.length > 0;

  // One controls row: unified date trigger (left) | channel pills (right)
  if (showTwoRowLayout) {
    return (
      <>
        <div style={styles.controlsRow}>
          <AnalyticsPeriodTrigger dateRangeDisplay={dateRangeDisplay} />
          <div style={styles.rightGroup}>
            <CompactChannelFilter
              channels={channels}
              selectedChannels={selectedChannels}
              onChannelsChange={onChannelsChange}
            />
          </div>
        </div>
        {showGuideModal && (
          <GuideModal onClose={() => setShowGuideModal(false)} />
        )}
      </>
    );
  }

  // Single row: unified date trigger + optional channel pills (when hideChannelFilter or no channels)
  return (
    <>
      <div style={styles.controlsRow}>
        <AnalyticsPeriodTrigger dateRangeDisplay={dateRangeDisplay} />
        <div style={styles.rightGroup}>
          {channels.length > 0 && !hideChannelFilter && (
            <div style={styles.channelFilterGroup}>
              <CompactChannelFilter
                channels={channels}
                selectedChannels={selectedChannels}
                onChannelsChange={onChannelsChange}
              />
            </div>
          )}
        </div>
      </div>
      {showGuideModal && (
        <GuideModal onClose={() => setShowGuideModal(false)} />
      )}
    </>
  );
}

const styles = {
  controlsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    width: '100%',
    minWidth: 0,
  },
  rightGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    flexShrink: 0,
    marginLeft: 'auto',
    minWidth: 0,
  },
  channelFilterGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexShrink: 0,
    paddingRight: '0', // Flush right to card edge
  },
  iconButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    borderRadius: '4px',
    border: '1px solid #e5e7eb',
    backgroundColor: '#ffffff',
    cursor: 'pointer',
    color: '#6b7280',
    position: 'relative',
    transition: 'all 0.15s ease',
    padding: '0',
  },
  badge: {
    position: 'absolute',
    top: '-4px',
    right: '-4px',
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    backgroundColor: '#ef4444',
    color: '#ffffff',
    fontSize: '10px',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};
